import tmhRequest from '@/config/tmhRequest'

export default {
    searchListJoinMemberStatusReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/joinmemberstatusreport/searchlistjoinmemberstatusreport',
            method: 'post',
            data: data,
        })
    },
    searchMemberAnalysisReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportJoinMemberStatusReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/joinmemberstatusreport/exportjoinmemberstatusreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/joinmemberstatusreport.js